module.exports = __webpack_public_path__ + "img/agendados.192258e1.svg";